import { Modal } from "@newsela/angelou";

import { ReportSource } from "@/view/constants/reportSources";
import ReportContentForm from "@/view/ReportContentForm";
import ReportContentFormHeading from "@/view/ReportContentForm/ReportContentFormHeading";
import useReportContent from "@/view/utils/useReportContent";
import {
  modalCss,
  reportContentFormCss,
  reportContentFormHeadingCss,
} from "./ReportContentFormModal.style";

interface Props {
  contentId: string;
  extraData?: Record<string, unknown>;
  reportContentModalProps: {
    closeModal: () => (isActive: boolean) => void;
    isActive: boolean;
    onEsc: () => void;
    triggerRef: { current: null };
  };
  setIsSubmitted?: (isSubmitted: boolean) => void;
  setReportContentModalActive: (isActive: boolean) => void;
  reportSource: ReportSource;
}

const ReportContentFormModal = ({
  contentId,
  extraData,
  reportContentModalProps,
  setIsSubmitted,
  setReportContentModalActive,
  reportSource,
}: Props) => {
  const {
    handleCancelReport,
    handleSubmitReport,
    handleTextAreaChange,
    problemDescription,
  } = useReportContent();

  return (
    <Modal
      {...reportContentModalProps}
      __cssFor={modalCss}
      ariaProps={{
        "aria-labelledby": "report-content-form-heading",
      }}
      onEsc={() => setReportContentModalActive(false)}
    >
      <ReportContentForm
        reportSource={reportSource}
        heading={
          <ReportContentFormHeading
            id="report-content-form-heading"
            customStyles={reportContentFormHeadingCss}
            level="h1"
            text={
              reportSource === "LessonPlanner"
                ? "Lesson Planner Feedback"
                : "Report content"
            }
          />
        }
        handleCancelReport={() => {
          handleCancelReport();
          setReportContentModalActive(false);
        }}
        handleSubmitReport={() => {
          /*
           * void because the ReportContentFormModal doesn't have error handling for handleSubmitReport
           * see https://github.com/newsela/lyceum/pull/3456#discussion_r1434449849
           */
          if (contentId && reportSource) {
            void handleSubmitReport({ contentId, extraData, reportSource });
            if (setIsSubmitted) {
              setIsSubmitted(true);
            }
            setReportContentModalActive(false);
          }
        }}
        handleTextAreaChange={handleTextAreaChange}
        rootStyles={reportContentFormCss}
        textAreaValue={problemDescription}
      />
    </Modal>
  );
};

export default ReportContentFormModal;
